module.exports = __webpack_public_path__ + "static/media/packages.f5a50827.svg";